import React from 'react';
import { moveType, CrudStatusEnum } from '../../consts/AdminConst';
import { Button } from './';
const DetailBottomButton = React.memo((props) => {
    var _a, _b, _c;
    return (React.createElement("div", { className: "flex justify-between" },
        props.formStatus === CrudStatusEnum.RegisterForm &&
            React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    (typeof (props.edit_undisplay) === "undefined" || !props.edit_undisplay) &&
                        React.createElement(Button, { onClick: () => props.moveHandler(moveType.Edit), tag: "\u7DE8\u96C6", disabled: false }),
                    React.createElement(Button, { optionClass: (typeof (props.edit_undisplay) === "undefined" || !props.edit_undisplay) ? "ml-4" : "", onClick: () => props.moveHandler(moveType.List), tag: "\u623B\u308B", disabled: false })),
                props.delete_display &&
                    React.createElement("div", null,
                        React.createElement(Button, { onClick: (_a = props.deleteConfirmHandler) !== null && _a !== void 0 ? _a : (() => { }), tag: "\u524A\u9664", disabled: false }))),
        props.formStatus === CrudStatusEnum.DeleteConfirm &&
            React.createElement(React.Fragment, null,
                React.createElement("div", null),
                React.createElement("div", null,
                    React.createElement(Button, { onClick: (_b = props.deleteHandler) !== null && _b !== void 0 ? _b : (() => { }), tag: "\u524A\u9664", disabled: false }),
                    React.createElement(Button, { optionClass: "ml-4", onClick: (_c = props.backHandler) !== null && _c !== void 0 ? _c : (() => { }), tag: "\u623B\u308B", disabled: false })))));
});
export default DetailBottomButton;
